import { render, staticRenderFns } from "./messageEdit.vue?vue&type=template&id=2da93efc&scoped=true"
import script from "./messageEdit.vue?vue&type=script&lang=js"
export * from "./messageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da93efc",
  null
  
)

export default component.exports